// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {228: "a4adef6d39ab7051",318: "c8edb7f9c4aa8a93",369: "f877d5d165bfb00f",580: "9615065d1704e1ce",700: "0105a9eb70355c73",}[chunkId] + ".js"
}